module.exports = __webpack_public_path__ + "static/media/plant.b08c12fe.svg";